import { ReportStates } from 'mmfintech-backend-api'
import { cleanupUnderscores, tr } from 'mmfintech-commons'

export const getStatusBadgeLabel = (status: string): string => {
  switch (status) {
    // Counterparties status labels
    case 'ACTIVE':
      return tr('FRONTEND.REPORTS.STATUSES.ACTIVE', 'Active')
    case 'ARCHIVED':
      return tr('FRONTEND.REPORTS.STATUSES.ARCHIVED', 'Archived')
    //End Counterparties status labels

    case ReportStates.NEW:
      return tr('FRONTEND.REPORTS.STATUSES.DRAFT', 'Draft')
    case ReportStates.EDIT:
      return tr('FRONTEND.REPORTS.STATUSES.RETURNED', 'Returned')
    case ReportStates.APPROVED:
      return tr('FRONTEND.REPORTS.STATUSES.AWAITING_PAYMENT', 'Awaiting payment')
    case ReportStates.WAITING_APPROVAL:
      return tr('FRONTEND.REPORTS.STATUSES.AWAITING_APPROVAL', 'Awaiting approval')
    case ReportStates.WAITING_FINANCE_APPROVAL:
      return tr('FRONTEND.REPORTS.STATUSES.AWAITING_FINANCE_APPROVAL', 'Awaiting finance approval')
    case ReportStates.REJECTED:
      return tr('FRONTEND.REPORTS.STATUSES.REJECTED', 'Rejected')
    case ReportStates.COMPLETELY_PAID:
      return tr('FRONTEND.REPORTS.STATUSES.PAID', 'Paid')
    case ReportStates.PARTIALLY_PAID:
      return tr('FRONTEND.REPORTS.STATUSES.PARTIALLY_PAID', 'Partially paid')
    case ReportStates.UNPAID:
      return tr('FRONTEND.REPORTS.STATUSES.UNPAID', 'Unpaid')
    default:
      return cleanupUnderscores(status)
  }
}
